import { render, staticRenderFns } from "./AddToZone.vue?vue&type=template&id=435b147e&"
import script from "./AddToZone.vue?vue&type=script&lang=js&"
export * from "./AddToZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports